import { render, staticRenderFns } from "./realTimeVideoGBNew.vue?vue&type=template&id=43544d84&scoped=true&"
import script from "./realTimeVideoGBNew.vue?vue&type=script&lang=js&"
export * from "./realTimeVideoGBNew.vue?vue&type=script&lang=js&"
import style0 from "./realTimeVideoGBNew.vue?vue&type=style&index=0&id=43544d84&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "43544d84",
  null
  
)

export default component.exports